import { render, staticRenderFns } from "./servingCounselingDetail.vue?vue&type=template&id=60808ba5&"
import script from "./servingCounselingDetail.vue?vue&type=script&lang=js&"
export * from "./servingCounselingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports